<template>
    <Card :bordered="false" class="border-radius-0" :class="{'ant-card-body-p-0': isChildren }">
        <CTable :isLoading="isLoading"
                v-model:columns="data.columns"
                v-model:page="data.page"
                :options="data.tableOptions"
                :manages="data.manages"
                :manageExtras="data.manageExtras"
                :rowActions="data.rowActions"
                :clientSide="true"
                :canRefresh="!isChildren"
                :visibleSearch="false"
        ></CTable>
    </Card>
</template>

<script>
    import { reactive } from "vue";
    import { Card } from "ant-design-vue";
    import { defineComponent, defineAsyncComponent } from "vue";
    import { isLoading, initData } from "./analysis-topic.logic";

    export default defineComponent({
        components: {
            Card,
            CTable: defineAsyncComponent(() => import("../../../../components/table/CTable"))
        },
        props: {
            menuContext: { required: true },
            viewOnly: {},
            useForm: {},
            parent: {},
            repeatOption: {},
            fetchCriteria: {},
            visibleSearch: { default: true },
            isChildren: { default: false },
            refLabTypeKey: {},
            refExtCenterTypeKey: {},
        },
        setup(props) {
            const data = reactive({});
            const refs = reactive({});
            initData({ props, data, refs });
            return {
                props,
                isLoading,
                data,
                refs,
            };
        },
    });
</script>